// src/components/ErrorBoundary.jsx
// Catches uncaught React render errors in any child tree.
// Reset by changing the `key` prop (e.g. key={activeModule}).

import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught error:', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const msg = this.state.error?.message || 'An unexpected error occurred.';

    return (
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 20,
        minHeight: 400,
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <div style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          border: '2px solid #f87171',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 24,
          color: '#f87171',
          flexShrink: 0,
        }}>
          !
        </div>
        <div>
          <div style={{
            fontFamily: 'Syne, sans-serif',
            fontWeight: 800,
            fontSize: 18,
            color: 'var(--t1)',
            marginBottom: 8,
          }}>
            Something went wrong
          </div>
          <div style={{
            fontSize: 11,
            color: 'var(--t3)',
            fontFamily: 'JetBrains Mono, monospace',
            maxWidth: 440,
            lineHeight: 1.7,
            wordBreak: 'break-word',
          }}>
            {msg}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={this.handleReset}
            style={{
              padding: '9px 20px',
              background: 'var(--cyan)',
              border: 'none',
              color: '#020508',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: '.1em',
              borderRadius: 3,
              cursor: 'pointer',
            }}
          >
            TRY AGAIN
          </button>
          <button
            onClick={() => { window.location.reload(); }}
            style={{
              padding: '9px 20px',
              background: 'transparent',
              border: '1px solid var(--b2)',
              color: 'var(--t3)',
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: 10,
              letterSpacing: '.1em',
              borderRadius: 3,
              cursor: 'pointer',
            }}
          >
            RELOAD PAGE
          </button>
        </div>
      </div>
    );
  }
}
